import { Alert, Box, Button, Card, Typography } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

import VanillaTilt from "vanilla-tilt";
import React, { useEffect, useRef } from "react";

/////////////////////////////////////////////////////////////////////////////////////////////

export const WavyDivider = styled("div")(({ theme, src }) => ({
  aspectRatio: "1920/200",
  width: "100%",
  backgroundRepeat: " no-repeat",
  backgroundPosition: "center",
  backgroundSize: "cover",
  backgroundImage: `url(${src})`,
  [theme.breakpoints.down("lg")]: { aspectRatio: "1920/400" },
  [theme.breakpoints.down("md")]: { aspectRatio: "1920/500" },
  [theme.breakpoints.down("sm")]: { aspectRatio: "1920/700" },
}));

/////////////////////////////////////////////////////////////////////////////////////////////

export const AfriqualeosTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 900,
  fontFamily: "Cabin, sans-serif",
}));

export const SubTitle = styled(Typography)(({ theme }) => ({
  color: "#FFF",
  fontWeight: 700,
  fontFamily: "Cabin, sans-serif",
}));

/////////////////////////////////////////////////////////////////////////////////////////////

export const MyButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
  textAlign: "center",
  color: "#FFF",
  borderRadius: "40px",
  background: " rgb(27, 169, 208)",
  background: `linear-gradient(53deg, ${theme.palette.secondary.main}  0%, ${theme.palette.primary.main} 100%)`,
  transform: "scale(1)",
  boxShadow: theme.customShadows.z8,
  transition: ` ${theme.transitions.create(
    ["background", "transform", "box-shadow"],
    {
      duration: theme.transitions.easing.easeInOut,
    }
  )}`,
  "&:hover": {
    background: ` linear-gradient(53deg,${theme.palette.secondary.main}  16%,${theme.palette.primary.main} 81%)`,
    boxShadow: theme.customShadows.primary,
  },
  "&:disabled": {
    background: "none",
  },
}));

export const MySecondButton = styled(Button)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
  textAlign: "center",
  color: theme.palette.secondary.dark,
  borderRadius: "40px",
  border: "none",
  transition: ` ${theme.transitions.create(
    ["background-color", "transform", "box-shadow"],
    {
      duration: theme.transitions.easing.easeInOut,
    }
  )}`,

  boxShadow: theme.customShadows.z8,
  "&:hover": {
    border: "none",
    color: theme.palette.secondary.main,
    background: "#FFF",
    boxShadow: theme.customShadows.secondary,
  },
}));

/////////////////////////////////////////////////////////////////////////////////////////////

export const SectionTitle = styled("h1")(({ theme }) => ({
  color: "#FFF",
  fontFamily: "Cabin, sans-serif",
  // fontFamily: "Josefin Sans , sans-serif",
  //fontFamily: "Nunito, sans-serif",
  fontWeight: "700",
  textShadow: `3px 3px ${theme.palette.primary.dark} `,
  fontSize: "40px",
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
  },
}));

export const SectionCentent = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1, 1),
  color: "#FFF",
  fontSize: "1.1rem",
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
  },
}));

export const SectionTitleSec = styled("h1")(({ theme }) => ({
  fontFamily: "Cabin, sans-serif",
  color: theme.palette.secondary.main,
  // fontFamily: "Josefin Sans , sans-serif",
  //fontFamily: "Nunito, sans-serif",
  fontWeight: "700",
  textShadow: `2.5px 2.5px ${theme.palette.primary.dark}`,
  fontSize: "40px",
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
  },
}));

export const SectionCententSec = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(1, 1),
  color: theme.palette.primary.dark,
  fontSize: "1.1rem",
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
  },
}));

export const SubTitleSec = styled(Typography)(({ theme, fontWeight }) => ({
  color: theme.palette.primary.dark,
  fontWeight: fontWeight,
  fontFamily: "Cabin, sans-serif",
}));

/////////////////////////////////////////////////////////////////////////////////////////////

export const BlueCardStyle = styled("div")(({ theme }) => ({
  // boxShadow: "none",
  // backdropFilter: "blur(7px)",
  // WebkitBackdropFilter: "blur(7px)", // Fix on Mobile
  //backgroundColor: "#1f94d2",
  //backgroundImage: "linear-gradient(135deg, #045381 0%, #1f94d2 80%)",

  backgroundColor: "none",
  margin: "40px",
  transformStyle: "preserve-3d",
  borderRadius: "20px",
  transform: "translateZ( 20px )",
  img: {
    borderRadius: "20px",
    boxShadow: theme.customShadows.primaryBlue,
    transform: "translateZ( 20px )",
  },
}));

export const WhiteCardStyle = styled("div")(({ theme }) => ({
  // boxShadow: "none",
  // backdropFilter: "blur(7px)",
  // WebkitBackdropFilter: "blur(7px)", // Fix on Mobile
  // backgroundColor: " #ffffff",
  //backgroundImage: "linear-gradient(135deg, #ffffff 19%, #1f94d2 100%)",
  // backgroundImage: "linear-gradient(135deg, #ffffff 29%,  #69caff 100%)",

  backgroundColor: "none",
  margin: "40px",
  transformStyle: "preserve-3d",
  borderRadius: "20px",
  transform: "translateZ( 20px )",
  img: {
    borderRadius: "20px",
    boxShadow: theme.customShadows.primaryDark,
    transform: "translateZ( 20px )",
  },
}));

export const NoShadowCard = styled("div")(({ theme }) => ({
  backgroundColor: "none",
  margin: "40px",
  transformStyle: "preserve-3d",
  borderRadius: "20px",
  transform: "translateZ( 20px )",
  img: {
    borderRadius: "20px",
    // boxShadow: theme.customShadows.primaryDark,
    transform: "translateZ( 20px )",
  },
}));

/////////////////////////////////////////////////////////////////////////////////////////////

export const Tilt = (props) => {
  const { options, ...rest } = props;
  const tilt = useRef(null);
  useEffect(() => {
    VanillaTilt.init(tilt.current, options);
  }, [options]);
  return (
    <div
      ref={tilt}
      {...rest}
      // style={{
      //   transformStyle: "preserve-3d",
      //   transform: "perspective(1000px)",
      // }}
    />
  );
};

export const StyledSuccessAlert = styled(Alert)(({ theme }) => ({
  backgroundColor: "#FFF",
  boxShadow: theme.shadows[4],
  color: theme.palette.info.main,
  borderLeft: `5px solid ${theme.palette.info.main}`,
  borderRight: `5px solid ${theme.palette.info.main}`,
  borderTop: `2px solid ${theme.palette.info.main}`,
  borderBottom: `2px solid ${theme.palette.info.main}`,

  ".MuiSvgIcon-root": {
    color: theme.palette.info.main,
  },
}));

export const StyledErrorAlert = styled(Alert)(({ theme }) => ({
  backgroundColor: "#FFF",
  boxShadow: theme.shadows[4],
  color: theme.palette.error.main,
  borderLeft: `5px solid ${theme.palette.error.main}`,
  borderRight: `5px solid ${theme.palette.error.main}`,
  borderTop: `2px solid ${theme.palette.error.main}`,
  borderBottom: `2px solid ${theme.palette.error.main}`,

  ".MuiSvgIcon-root": {
    color: theme.palette.error.main,
  },
}));

export const WhiteSection = styled(Box)(({ theme }) => ({
  background: "none",
  padding: theme.spacing(5, 0),
}));
export const BlueSection = styled(Box)(({ theme }) => ({
  background: theme.palette.primary.light,
  padding: theme.spacing(5, 0),
}));
